import { useAuth0 } from '@auth0/auth0-react';

import { ProviderLogin, ProviderLoginBaseProps } from './ProviderLogin';

export function ProviderLoginWrapper(props: ProviderLoginBaseProps) {
  const { loginWithRedirect } = useAuth0();

  return <ProviderLogin onLogin={() => loginWithRedirect()} {...props} />;
}
